import page from 'page';

import { session } from '../session';

// Position of the current page within the in-app forward-navigation sequence.
// Maintained by the page.js '*' middleware in setupBaseRoutes (utils/routes.ts):
// the first in-app page is 1 and each new forward navigation increments it, so
// any value > 1 means there is a previous in-app page behind us in the browser
// history. Kept here (rather than as a local in setupBaseRoutes) so cancel/back
// handlers can consult it without importing the route setup.
let currentPositionInHistory = 0;

export function getCurrentPositionInHistory(): number {
  return currentPositionInHistory;
}

export function setCurrentPositionInHistory(value: number): void {
  currentPositionInHistory = value;
}

// True when we reached the current page by navigating within the app, so the
// previous browser entry is one of ours.
function hasInAppBackHistory(): boolean {
  return currentPositionInHistory > 1;
}

// Cancel/back handler: return to the previous in-app page when we navigated here from within the app;
// otherwise fall back to the tenant home.
export function goBackOrHome(): void {
  if (hasInAppBackHistory()) {
    history.back();
  } else {
    page.redirect(session.toTenantPath('/'));
  }
}
